import { render, staticRenderFns } from "./xeSimpleCard.vue?vue&type=template&id=889054f8&scoped=true"
import script from "./xeSimpleCard.vue?vue&type=script&lang=js"
export * from "./xeSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./xeSimpleCard.vue?vue&type=style&index=0&id=889054f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889054f8",
  null
  
)

export default component.exports